import "../css/table.css";
import React, { useEffect } from "react";
import logo from "../geuzenetlog.png";
import { useNavigate } from "react-router-dom";
import { getQIncidents } from "../store/actions/qIncidents";
import { selectQIncidents } from "../store/selectors/qIncidents";
import { useDispatch, useSelector } from "react-redux";

function QIncidentsNl() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let incidents = useSelector(selectQIncidents);
  useEffect(() => {
    if (window.self === window.top) {
      navigate(`/`);
    } else {
      dispatch(getQIncidents());
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let content =
    incidents !== "loading"
      ? incidents
          .filter((incident) => incident.toBeShown)
          .filter((incident) => incident.updatesNL.length > 0)
      : [];

  return incidents !== "loading" && content.length > 0 ? (
    <div>
      {content.map((incident) => {
        console.log(incident);
        return (
          <div className="incMain">
            <div className="incTitle">{incident.pageTitle}</div>
            <div>
              {incident.updatesNL.map((update) => {
                return <div className="incUpdates">{update}</div>;
              })}
            </div>
          </div>
        );
      })}
    </div>
  ) : incidents !== "loading" ? (
    <div className="incUpdates">
      Er zijn momenteel geen algemene storingen bekend
    </div>
  ) : (
    <img className="landingLogo" src={logo} alt="company logo" />
  );
}

export default QIncidentsNl;
